<template>
    <div>
        <div class="break-after width-100 relative m-b-md">
            <h3 class="card-title-text">Twitter preview</h3>
            <Toast width="expand" v-if="errors.msg" :variant="errors.status">{{errors.msg}}</Toast>
        </div>
        <Card>
            <div class="post-preview-wrap" id="twitter-preview">
                <div class="post-preview-user-wrap">
                    <Avatar variant="social-preview"></Avatar>
                </div>
                <div class="post-preview-content">
                    <div class="post-preview-user-info"><div class="post-preview-user-name">Cas van Grunsven</div><div class="post-preview-user-subinfo">@casvgrunsven</div><div class="post-preview-user-subinfo">5 min.</div></div>
                    <p>{{post.text}}</p>
                    <div  v-if="post.media.type === 'image'" class="post-preview-thumb twitter">
                        <img v-bind:src="post.media.url"/>
                    </div>
                    <div class="post-preview-dummies">
                        <div class="post-preview-dummy">
                            <svgicon name="comment_rounded" />
                        </div>
                        <div class="post-preview-dummy">
                            <svgicon name="loop" />
                        </div>
                        <div class="post-preview-dummy">
                            <svgicon name="heart" />
                        </div>
                        <div class="post-preview-dummy">
                            <svgicon name="email" />
                        </div>
                    </div>
                </div>

            </div>
        </Card>
    </div>
</template>
<script>
    import Toast from "../../../Toast/Toast";
    import Card from "../../../Card/Card";
    import Avatar from "../../../Avatar/Avatar";
    export default {
        name: 'Twitter',
        components: {
            Avatar,
            Card,
            Toast

        },
        props: ['post', 'errors'],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }
</script>
<style src="./Twitter.scss" scoped lang="scss"></style>
